const KEYS = {
  DASH: '-',
};

export default KEYS;
